import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {getParam} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import {getDataSpec, getClass, addClassToDataSpec, editClass, deleteClass} from "../utils/utilsDataSpec";

import D3Graphviz from "../components/D3Graphviz";

import ViewClass from "../components/ViewClass";
import ViewDataSpec from "../components/ViewDataSpec";
import ViewMetadata from "../components/ViewMetadata";

import SelectEntity from "../components/SelectEntity";
import SelectRelationship from "../components/SelectRelationship";

import FormProperty from "../components/FormProperty";
import ListProperties from "../components/ListProperties";


import Revision from "../components/Revision";
import ListRevisions from "../components/ListRevisions";

import Rendition from '../components/Rendition';

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Class extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.addProperty = this.addProperty.bind(this);
        this.removeProperty = this.removeProperty.bind(this);
        this.updateProperty = this.updateProperty.bind(this);
        this.movePropertyUp = this.movePropertyUp.bind(this);
        this.movePropertyDown = this.movePropertyDown.bind(this);

        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadDataSpec(id){

        this.setState({renderState: "loading"});

        const onLoad = (DataSpec) => {
            this.FallBackNavigation = `/dataspec/${DataSpec._id}`;

            let StateChange = {
                DataSpec: DataSpec,
                idDataSpec: DataSpec._id,
                renderState: "loaded"
            };

            if (this.state.mode === 'new'){
                StateChange.FormData = {
                    status: 'in use',
                    Properties: []
                };
            }

            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id === DataSpec.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "delete":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Classes to this Data Spec";
                        break;
                }
            }

            this.setState(StateChange);
        };

        const onFail = (e) => {
            this.setState({
                renderState: "failed",
                errorMessage: e.message
            });
        };

        getDataSpec(this.dsd, id, onLoad, onFail);
        
    };

    loadClass(id){

        this.setState({renderState: "loading"});

        const onLoad = (Class) => {
            this.FallBackNavigation = `/dataspec/${Class.DataSpec._id}`;

            let StateChange = {
                DataSpec: Class.DataSpec,
                idDataSpec: Class.DataSpec._id,
                Class: Class,
                FormData: Class,
                renderState: "loaded"
            };

            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id === Class.DataSpec.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "delete":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Classes to this Data Spec";
                        break;
                }
            }

            if (Class.DataSpec){
                StateChange.DataSpec = Class.DataSpec;
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsDataSpec(Class.DataSpec._id);
                }
            }

            this.setState(StateChange);

            this.fetchViz(id);

        };

        const onFail = (e) => {
            this.setState({
                renderState: "failed",
                errorMessage: e.message
            });
        };

        getClass(this.dsd, id, onLoad, onFail);
        
    };

    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getClass(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };

    setup(){

        let StateChange = {

            mode: "view",

            idClass: null,
            idDataSpec: null,

            DataSpec: null,
            Class: null,

            renderState: null,

            FormData: {},
            OfferEdit:false,

            Controls: {
            },

            countRevisions: null,

            dot: null

        };

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idClass = getParam('id', this.props);
        StateChange.idDataSpec = getParam('idDataSpec', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idDataSpec){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Data Spec not specified when adding a Class"
                }
                break;
            default:
                if (StateChange.idDataSpec){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Data Spec should not be specified for an existing Class"
                }
                if (!StateChange.idClass){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Class not specified for an existing Class"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idDataSpec){
                this.FallBackNavigation = `/dataspec/${StateChange.idDataSpec}`;
            }        
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);

        // Direct orchestration
        if (StateChange.idDataSpec && StateChange.mode === 'new'){
            this.loadDataSpec(StateChange.idDataSpec);
        }

        if (StateChange.idClass){
            this.loadClass(StateChange.idClass);
        }
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        const onAdd = (idClass) => {
            this.props.navigation(`/class/${idClass}`);
        };

        const onUpdate = () => {
            this.props.navigation(`/class/${this.state.idClass}`);
        };

        const onDelete = () => {
            this.props.navigation(this.FallBackNavigation);
        };

        const onError = (error) => {
            this.setState({
                renderState: error.status,
                errorMessage: error.errorMessage
            });
        };

        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                    case "delete":
                        this.props.navigation(`/class/${this.state.idClass}`);
                        break;
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;
            case 'btnDelete':
                this.setState({renderState: "updating"});
                deleteClass(this.dsd, this.state.idDataSpec, this.state.idClass, onDelete, onError);
                break;
            case 'btnSave':
            default:

                this.setState({renderState: "updating"});
        
                switch (this.state.mode){
                    case 'new':
                        addClassToDataSpec(this.dsd, this.state.idDataSpec, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editClass(this.dsd, this.state.idClass, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    addProperty(){
        let FormData = {...this.state.FormData};
        FormData.Properties = [...(FormData.Properties || []), {}];
        
        this.setState({"FormData": FormData});
    }

    removeProperty(seq){
        let FormData = {...this.state.FormData};
        FormData.Properties = [...(FormData.Properties || [])];
        FormData.Properties.splice(seq-1, 1);
        
        this.setState({"FormData": FormData});
    }


    movePropertyUp(seq){
        let FormData = {...this.state.FormData};
        FormData.Properties = [...(FormData.Properties || [])];
        
        // Swap with previous item
        [FormData.Properties[seq-2], FormData.Properties[seq-1]] = 
        [FormData.Properties[seq-1], FormData.Properties[seq-2]];
        
        this.setState({"FormData": FormData});
    }

    movePropertyDown(seq){
        let FormData = {...this.state.FormData};
        FormData.Properties = [...(FormData.Properties || [])];
        
        // Swap with next item
        [FormData.Properties[seq-1], FormData.Properties[seq]] = 
        [FormData.Properties[seq], FormData.Properties[seq-1]];
        
        this.setState({"FormData": FormData});
    }


    updateProperty(seq, Property){

        let FormData = {...this.state.FormData};
        FormData.Properties = [...(FormData.Properties || [])];
        FormData.Properties[seq-1] = Property;

        this.setState({"FormData": FormData});

    }


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'structure':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };


    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);


    };


    visualise(){
    
        if (!this.state.Class){
            return null;
        }

        try {

            return(
                <D3Graphviz dot={this.state.dot} onClick={this.handleVizClick}/>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Class</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Radio label="Source Type" name="sourceType" value={this.state.FormData.sourceType} onChange={this.handleChange}>
                                        {
                                            this.dsd.config.ClassSourceTypes.map(
                                                (type, posType) => 
                                                    {
                                                        return(
                                                            <label key={posType}>{type}</label>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Radio>

                                    {this.state.FormData.sourceType=='entity' &&
                                        <fieldset>
                                            <legend>Entity</legend>                              
                                            <SelectEntity name="idEntity" label="Entity" selectLogicalModel={true} onChange={this.handleChange} value={this.state.FormData.idEntity}/>
                                        </fieldset>
                                    }

                                    {this.state.FormData.sourceType=='relationship' &&
                                        <fieldset>
                                            <legend>Relationship</legend>                              
                                            <SelectRelationship name="idRelationship" label="Relationship" selectLogicalModel={true} onChange={this.handleChange} value={this.state.FormData.idRelationship}/>
                                        </fieldset>
                                    }

                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    {this.FormProperties()}

                                    <Revision ref={this.refRevision}  idAbout={this.state.idClass}/>

                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'delete':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Class</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button name="btnDelete" onClick={this.handleSubmit} type="warning" value="confirm delete?" />
                        <PD.Button name="btnCancel" onClick={this.handleSubmit} type="warning" value="cancel" />
                        <ViewClass Class={this.state.Class}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        let countProperties = 0;
                        if (this.state.Class.Properties){
                            countProperties = this.state.Class.Properties.length;
                        }

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Class:{this.state.Class.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                            <PD.Button onClick={this.handleMode} type="submit" value="delete" />
                                    </span>
                                }

                                <ViewClass Class={this.state.Class}/>

                                <br/>

                                <PD.Tabs>

                                    <div label='Visualise'>
                                        {this.visualise()}
                                    </div>

                                    <div label={`Properties(${countProperties})`}>
                                        <ListProperties Properties={this.state.Class.Properties}/>
                                    </div>

                                    <div label='Data Spec'>
                                        <ViewDataSpec DataSpec={this.state.DataSpec} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Class} />
                                    </div>

                                    <div label={<span>Revisions({this.state.countRevisions === null ? <Buffering/> : this.state.countRevisions})</span>} data-forcerender="true">
                                        <ListRevisions OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idClass}} onLoad={this.loadedRevisions}/>
                                    </div>

                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/classes"
                                            id={this.state.idClass}
                                        />
                                    </div>

                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };


    FormProperties(){

        let seqNext = 1;
        if (this.state.FormData.Properties){
            seqNext = this.state.FormData.Properties.length + 1;
        }
        let boolNew = true;
        if (seqNext > 1){
            if (Object.keys(this.state.FormData.Properties[seqNext-2]).length == 0){
                boolNew = false;
            }
        }
        return (
            <fieldset>
                <legend>Properties</legend>
                {this.state.FormData.Properties &&
                    this.state.FormData.Properties.map(
                        (Property, posProperty) => 
                        {
                            let seq = posProperty+1;
                            return(
                                this.FormProperty('edit', seq, Property)
                            )
                        }
                    )
                }
                {boolNew &&
                    this.FormProperty('new', seqNext)}
            </fieldset>
        );

    }

    FormProperty(mode, seq, Property = {}){
        let idEntity = null;
        let idRelationship = null;

        switch (this.state.FormData.sourceType){
            case 'entity':
                idEntity = this.state.FormData.idEntity;
                break;
            case 'relationship':
                idRelationship = this.state.FormData.idRelationship;
                break;    
        }

        let onMoveUp = null;
        if (seq>1) {
            onMoveUp = this.movePropertyUp;
        }

        let onMoveDown = null;
        if (this.state.FormData.Properties){
            if (seq<this.state.FormData.Properties.length) {
                onMoveDown = this.movePropertyDown;
            }
        }

        return(
            <div key={seq.toString()}>
                <FormProperty 
                    key={seq.toString()}
                    parentSourceType={this.state.FormData.sourceType}
                    idEntity={idEntity}
                    idRelationship={idRelationship}
                    mode={mode}
                    onAdd={this.addProperty}
                    onRemove={this.removeProperty}
                    onUpdate={this.updateProperty}
                    {...(onMoveUp && { onMoveUp:onMoveUp})}
                    {...(onMoveDown && { onMoveDown:onMoveDown})}
                    Property={Property}
                    seq={seq}/>
            </div>
        )
    }

};

// Wrap and export
export default function Class_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Class {...props} navigation={navigation} location={location} params={params} />;
  }
